import React, { useEffect, useState } from 'react';
import styles from './DropdownRow.module.css';
import classNames from 'classnames';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

/**
 * A horizontal row with optional dropdown
 * @param {{children: Component[], className?: string, openedClassName?: string, rowClassName?: string, contentClassName?: string, contentId?: string}}
 * @example
 * <DropdownRow contentId="content">
 *    <div>Name {name}</div>
 *    <div>ID {id}</div>
 *    <div id="content">{name} has the ID of {id}</div>
 * </DropdownRow>
 */
export default function DropdownRow({
  children,
  className = '',
  openedClassName = '',
  rowClassName = '',
  contentClassName = '',
  contentId = 'content',
  onClick = () => {},
}) {
  const [open, setOpen] = useState(false);

  const filteredChildren = () =>
    children.filter(
      (child) =>
        typeof child === 'object' && child !== null && Object.keys(child).includes('$$typeof'),
    );

  const toggleOpen = () => {
    if (
      Array.isArray(filteredChildren()) &&
      filteredChildren()?.find((child) => child?.props?.id === contentId)
    )
      setOpen(!open);

    onClick();
  };

  return (
    <div className={classNames(styles['root'], className, open ? openedClassName : '')}>
      <div className={classNames(styles['row-container'], rowClassName)} onClick={toggleOpen}>
        {Array.isArray(filteredChildren())
          ? filteredChildren()?.filter((child) => child?.props?.id !== contentId)
          : filteredChildren()}

        {Array.isArray(filteredChildren()) &&
          filteredChildren()?.find((child) => child.props.id === contentId) && (
            <div className={styles['dropdown-indicator']}>
              {open && <FaChevronUp />}
              {!open && <FaChevronDown />}
            </div>
          )}

        {Array.isArray(filteredChildren()) &&
          !filteredChildren()?.find((child) => child.props.id === contentId) && (
            <FaChevronUp color="transparent" />
          )}
      </div>

      {Array.isArray(filteredChildren()) && open && (
        <div className={classNames(styles['content-container'], contentClassName)}>
          {filteredChildren()?.filter((child) => child.props.id === contentId)}
        </div>
      )}
    </div>
  );
}
